import { FC } from 'react';

import CustomLoading from 'modules/_shared/components/CustomLoading';

import { useEditShareModal } from './context/EditShareModalContext';

import EditShareModalHeader from './components/EditShareModalHeader';
import EditShareModalBody from './components/EditShareModalBody';
import EditShareModalFooter from './components/EditShareModalFooter';

const EditShareModal: FC = () => {
  const { data } = useEditShareModal();

  return (
    <>
      <EditShareModalHeader />
      <EditShareModalBody />
      <EditShareModalFooter />

      {data.isLoading && <CustomLoading />}
    </>
  );
};

export default EditShareModal;
